import { Box, Card, Center, HStack, Spinner, Text, VStack } from '@chakra-ui/react';
import { useTranslate } from '@tolgee/react';
import { toaster } from 'provider/src/module/chakra-ui/components/ui/toaster';
import { useParams } from 'react-router-dom';
import { useUpdatePrintRule } from '../logic/use-edit-print-rule';
import { usePrintRule } from '../logic/use-get-print-rule';
import PrinterDeviceSelectionPrintRuleDetail from './printer-device-selection-print-rule-detail';

interface PrinterDeviceCardProps {
  printRuleId: string;
}

export default function PrinterDeviceCard({ printRuleId }: PrinterDeviceCardProps) {
  const { t } = useTranslate();
  const menuId = useParams().menuId ?? '';
  const { data, loading } = usePrintRule(printRuleId);
  const [updatePrintRule, { loading: updateLoading }] = useUpdatePrintRule();

  if (loading) {
    return (
      <Center colorPalette={'teal'}>
        <Spinner m={4} colorPalette="blue.500" borderWidth="2px" />
      </Center>
    );
  }

  const handlePrinterChange = (printerId: string) => {
    updatePrintRule({
      variables: {
        id: printRuleId,
        input: {
          menuId,
          name: data?.printRule.name ?? '',
          printerDeviceId: printerId === '' ? null : printerId,
        },
      },
    })
      .then(() => {
        toaster.create({
          description: t('print-rule.update.alert', 'Update print rule successful'),
          type: 'info',
        });
      })
      .catch(() => {
        toaster.create({
          description: t('print-rule.update.alert.failed', 'Update print rule failed'),
          type: 'error',
        });
      });
  };

  return (
    <Box bgColor={'white'} px={4} maxW={'5xl'} shadow={'sm'} rounded={'md'}>
      <Card.Root border={'none'}>
        <Card.Header px={0}>
          <HStack justifyContent={'space-between'}>
            <HStack alignItems={'center'} spaceX={2} fontSize={'xl'} fontWeight={600}>
              <Text display={'inline-block'}>{t('print-rule.primary-printer.header', 'Primary printer')}</Text>
              {updateLoading && <Spinner m={4} colorPalette="blue.500" borderWidth="2px" />}
            </HStack>
          </HStack>
        </Card.Header>
        <Card.Body px={0}>
          <VStack gapY={4} maxW={'lg'} gap={3}>
            <Text color={'gray.500'} fontStyle={'italic'} fontSize={'sm'}>
              {t('primary-printer.des')}
            </Text>
            <PrinterDeviceSelectionPrintRuleDetail
              printerDeviceId={data?.printRule.printerDeviceId ?? undefined}
              onChange={handlePrinterChange}
            />
          </VStack>
        </Card.Body>
      </Card.Root>
    </Box>
  );
}
